<template>
  <div>
    <vs-prompt
      title="Select revision"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="View revision"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <vs-select
            v-if="revisionDates"
            label="Revision"
            class="w-full"
            v-model="selectedRevision"
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="
                'Revision ' +
                item +
                ' (Created ' +
                formatDate(revisionDates[index]) +
                ')'
              "
              v-for="(item, index) in revisions"
            />
          </vs-select>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      selectedRevision: "",
      revisionDates: undefined,
      id: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.selectedRevision && this.selectedRevision !== "";
    },
    revisions() {
      return this.revisionDates ? Object.keys(this.revisionDates) : [];
    },
  },
  methods: {
    show(id, revisionDates) {
      this.selectedRevision = "";
      this.id = id;
      this.revisionDates = revisionDates;
      this.prompt = true;
    },
    async accept() {
      this.$router
        .push({
          name: "crm-legaldocument-revision",
          params: { id: this.id, revision: this.selectedRevision },
        })
        .catch((e) => {
          console.log("Profile lookup", e);
        });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
